// @ts-nocheck
import React, { useEffect, useState } from 'react';

import { BoxedDiv } from 'psims/react/components/layout';
import Button from 'psims/react/components/button';
import { InputNew as Input } from 'psims/react/components/input';
import Divider from 'psims/react/components/divider';
import { UseAddUser } from './use-add-user';
import Select from 'psims/react/components/select';
import { asString } from 'psims/lib/string';
import Notification from 'psims/react/components/notification';
import { useAppOverlay } from 'psims/react/providers/app-overlay';
import Modal from 'psims/react/components/modal';
import Spinner from 'psims/react/components/spinner';
import Text from 'psims/react/components/text';
import { StatusField } from './shared';
import { H2, H3 } from 'psims/react/components/typography';
import { useReportingObligations } from 'psims/react/providers/api/reporting-obligations';
import Checkbox from 'psims/react/components/checkbox';
import { any } from 'psims/lib/collections';
import './addUserclass.css'


interface AddUserProps {
    ctrl: UseAddUser;
}

interface ReportingObl {
                    reportingObligationId:number | null,
                    reportingObligationName:string | null,
                    hasAccess:boolean | null
                }; 


const AddUser = (props: AddUserProps) => {
     const vm = useVM(props);
    const [userReporObligation, setUserReportObligation] = useState([vm.user?.userReportAccesses])
    const [checkedYN, setCheckedYN] = useState<number>(0)
    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const reportingObligationId:number = Number(e.target.value);
        const hasAccess:boolean = e.target.checked;

        if(hasAccess){
                const updatedArray = vm.user?.userReportAccesses?.map(item => {
                if (item.reportingObligationId === reportingObligationId) {
             return { ...item, hasAccess:true };
                }
                 return item; // Return other items as they are
                });
          vm.updateUser('userReportAccesses', updatedArray)
          setCheckedYN(prev => prev + 1)
        }
        else{
                const updatedArray = vm.user?.userReportAccesses?.map(item => {
                if (item.reportingObligationId === reportingObligationId) {
             return { ...item, hasAccess:false };
                }
                 return item; // Return other items as they are
                });      
          vm.updateUser('userReportAccesses', updatedArray)
          setCheckedYN(prev => prev - 1)
        }
        
    }

 
  
        const handlerForCompanyAdmin = () => {
        return true
    }
     
  
    

    const handleSelectAllClick = () =>{
      const allROArray = vm.user?.userReportAccesses?.map(item => {
                 {
             return { ...item, hasAccess:true };
                }
                 
                });
          vm.updateUser('userReportAccesses', allROArray)
          setCheckedYN(allROArray?.length)
    }
    const handleClearAllClick = () =>{
        
        const clearROArray = vm.user?.userReportAccesses?.map(item => {
                 {
             return { ...item, hasAccess:false };
                }
                 
                });
          vm.updateUser('userReportAccesses', clearROArray)
          setCheckedYN(0)
    }

    if (vm.user === null) {
        return null;
    }

    return (
        <BoxedDiv box={{flex: 'column'}}>
            <H2>Add user account</H2>

            <BoxedDiv box={{flex: 'column', flexGrow: 1}}>
                <BoxedDiv box={{flex: 'row', marginTop: 2}}>
                    <Text weight='semibold'>User account</Text> <Text variant="muted">&nbsp;(e.g. firstname.lastname@dcceew.gov.au)</Text>
                </BoxedDiv>

                <Input
                    autoFocus={true}
                    error={vm.validationMessages.email}
                    forceError={vm.saveAttempted}
                    hideLabel={true}
                    id='email'
                    label='User account (e.g. firstname.lastname@dcceew.gov.au)'
                    onChange={e => vm.updateUser('email', e.target.value)}
                    type='email'
                    value={asString(vm.user.email)}
                />
            </BoxedDiv>

            <BoxedDiv box={{flex: 'row'}}>
                <Input
                    id='firstname'
                    error={vm.validationMessages.firstName}
                    forceError={vm.saveAttempted}
                    label='First name'
                    flexGrow={1}
                    marginRight={4}
                    onChange={e => vm.updateUser('firstName', e.target.value)}
                    value={asString(vm.user?.firstName)}
                />

                <Input
                    id='surname'
                    error={vm.validationMessages.lastName}
                    forceError={vm.saveAttempted}
                    label='Surname'
                    flexGrow={1}
                    marginLeft={4}
                    onChange={e => vm.updateUser('lastName', e.target.value)}
                    value={asString(vm.user?.lastName)}
                />
            </BoxedDiv>

            <BoxedDiv box={{flex: 'row'}}>
                <Select
                    error={vm.validationMessages.roleType}
                    flexGrow={1}
                    forceError={vm.saveAttempted}
                    id='roletype'
                    label='Role type'
                    marginRight={4}
                    placeholder='Select a role type'
                    options={vm.selectRoleCtrl.options}
                    onChange={vm.selectRoleCtrl.onChange}
                    value={vm.selectRoleCtrl.value}
                />
                <BoxedDiv box={{flexGrow: 1, marginLeft: 4}} />
                
            </BoxedDiv>
                  <BoxedDiv box={{flex: 'column'}}  >
                    <label className='labelclass'>Select Reporting Obligation</label>
                   {(checkedYN === 0 && vm.selectRoleCtrl.value?.value === 2) && <label role='alert' className="sc-eldPxv eEjepK alertclass">{"Please select atleast one reporting obligation"}</label>}
                        {
                        vm?.user?.userReportAccesses?.map((data, index) => (
                            <BoxedDiv className='forBox' box={{flex: 'row'}} key={data.reportingObligationId}>
                        <input
                            name= "ReportingObligation"
                            className='checkboxClass'
                            id={data.reportingObligationId?.toString()}
                            type="checkbox"                            
                            key={data.reportingObligationId} 
                            checked={vm.selectRoleCtrl.value?.value === 1 ? handlerForCompanyAdmin() : data.hasAccess}
                            value={data.reportingObligationId} 
                            onChange={(e) => handleChange(e)} 
                            aria-label={data.reportingObligationName}
                           disabled={vm.selectRoleCtrl.value?.value === 1 ? true : false}
                        />
                        <label 
                        htmlFor="ReportingObligation"
                        >{data.reportingOrganisationName} - {data.reportingObligationName}</label>
                         </BoxedDiv>
                        ))
                    }
                    
                    {vm.selectRoleCtrl.value?.value === 2 
                    && (<>
                        <BoxedDiv box={{flexGrow: 1, marginLeft: 4, marginBottom: 4}} />
                        <BoxedDiv box={{flex: 'row'}}>
                            <Button $kind={'primary'} $size='sm' marginRight={6} onClick={handleSelectAllClick}>Select All</Button>
                            <Button $kind={'text'} $size='sm' onClick={handleClearAllClick}>Clear All</Button>
                        </BoxedDiv>
                        </>
                    )}
                

            </BoxedDiv>

            <StatusField status='New' />

            <BoxedDiv box={{marginTop: 2}}>
                <Divider />
            </BoxedDiv>

            {
                vm.serviceError &&

                <BoxedDiv box={{marginV: 1}}>
                    <Notification align='center' kind='warning'>
                        {vm.serviceError}
                    </Notification>
                </BoxedDiv>
            }

            <BoxedDiv box={{flex: 'row-reverse', justifyContent: 'flex-start', marginTop: 3.5}}>
                <Button $kind='primary' marginLeft={6} onClick={vm.save} disabled={(checkedYN === 0 && vm.selectRoleCtrl.value?.value === 2) ? true : false} >Save</Button>

                <Button $kind='text' onClick={vm.cancel}>Cancel</Button>
            </BoxedDiv>
        </BoxedDiv>
    )
}

function useVM({ctrl: {user, cancel, roleOptions, save, saveAttempted, selectRoleCtrl, serviceError, serviceStatus, statusOptions, updateUser, userReportobli, validationMessages}}: AddUserProps) {
    const {setOverlay} = useAppOverlay();
    const { reportingObligations, status: reportingObligationsStatus } = useReportingObligations();
    
    useEffect(() => {
        if (serviceStatus === 'loading') {
            setOverlay(<Modal>
                <BoxedDiv box={{alignItems: 'center', flex: 'row'}}>
                    <Spinner size='lg' />
                    <BoxedDiv box={{alignItems: 'center', flex: 'row', marginLeft: 1}}>
                        <Text>Saving user...</Text>
                    </BoxedDiv>
                </BoxedDiv>
            </Modal>)
        } else {
            setOverlay(null);
        }
    }, [serviceStatus, setOverlay]);

    return {
        cancel,
        roleOptions,
        serviceError,
        save,
        saveAttempted,
        selectRoleCtrl,
        statusOptions,
        updateUser,
        user,
        reportingObligations,
        validationMessages,
    };
}


export default AddUser;
